import React from 'react';
import { DateTime } from 'luxon';
import messages from '../messages';
import symbols from './symbols';

function TooltipDate({ label, date, lang }) {
	if (date) {
		return (
			<tr>
				<td>{label} </td>
				<td>{DateTime.fromJSDate(date).setLocale(lang).toLocaleString()}</td>
			</tr>
		);
	} else {
		return null;
	}
}

function getUpdateTypeClassName(table) {
	const dt = table.correctedAt ?? table.updatedAt ?? new Date('2000-01-01T00:00:00Z');

	const last3Days = new Date();
	last3Days.setDate(last3Days.getDate() - 3);

	const lastMonth = new Date();
	lastMonth.setMonth(lastMonth.getMonth() - 1);

	if (dt > last3Days) {
		return ' last-3-days';
	} else if (dt > lastMonth) {
		return ' last-month';
	}
	return '';
}

export default function Table({ table, lang, odd, frSymbols = [] }) {
	if (!table) return null;

	const trans = table.translations[lang];
	const { REACT_APP_TABLES_BASEURL } = process.env;

	const tableUrl = `${REACT_APP_TABLES_BASEURL}/${table.id.substr(0, 3)}/${lang}/${table.id}.html`;
	const localizedNDash = lang === 'en' ? ' \u2013 ' : '\u2013';

	return (
		<tr className={odd ? 'fill' : ''}>
			<td width='10' valign='top'>
				<a
					href={tableUrl}
					style={{
						textDecoration: 'none',
						marginRight: '3px'
					}}>
					{table.number}
				</a>
			</td>
			<td valign='top'>
				<span className={'info' + getUpdateTypeClassName(table)}>
					<span className='tooltip'>
						<div>
							<table style={{ width: '100%' }}>
								<tbody>
									<TooltipDate label={messages[lang].correctedAt} date={table.correctedAt} lang={lang} />
									<TooltipDate label={messages[lang].updatedAt} date={table.updatedAt} lang={lang} />
									<TooltipDate label={messages[lang].nextUpdate} date={table.nextUpdate} lang={lang} />
								</tbody>
							</table>
						</div>
					</span>
				</span>
				<a
					href={tableUrl}
					style={{ textDecoration: 'none' }}>
					<span>{trans.title} </span>
					{ trans.refPeriodStart || trans.refPeriodEnd ? (
						<span className='nowrap'>({trans.refPeriodStart}{localizedNDash}{trans.refPeriodEnd})</span>
					) : null }
					{frSymbols.map(x => (
						<span key={x.name} style={{ marginLeft: '4px' }} dangerouslySetInnerHTML={{
							__html: symbols[x.symbol]
						}} title={x.name}></span>
					))}
				</a>
			</td>
		</tr>
	);
}
